<template>
  <div>
    <b-table
      hover
      small
      head-variant="dark"
      :items="columns"
      :fields="'#|name|type|new_type|keep'.split('|')">
      <template v-slot:cell(#)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(type)="data">
        {{ data.item.type }}
      </template>
      <template v-slot:cell(new_type)="data">
        <b-form-select
          size="sm"
          :required="true"
          v-model="map[data.item.slug].type"
          :options="'numeric|datetime|bool|string'.split('|')"/>
      </template>
      <template v-slot:cell(keep)="data">
        <div class="text-right">
          <b-form-checkbox
            v-model="map[data.item.slug].keep"
            :name="`checkbox-${data.item.slug}`"/>
        </div>
      </template>
    </b-table>

    <div class="mt-4 text-right">
      <b-button
        v-if="supportNext && !isDirty"
        variant="primary"
        class="px-5"
        @click="onSuccess">
        Finish
      </b-button>

      <b-button
        v-else
        variant="primary"
        class="px-5"
        @click="onSave"
        :disabled="isSaving || !isDirty">
        <template v-if="isSaving">
          <i class="fa fa-spin fa-spinner mr-2"></i>
          This might take a while
        </template>
        <template v-else>
          <span>Save&nbsp;</span>
          <span v-if="supportNext">& Finish</span>
          <span v-else>Changes</span>
        </template>
      </b-button>
    </div>
  </div>
</template>

<script>
	import {fullURL} from '../../utils';
	import axios from 'axios';
	import {registerListener, unregisterListener} from '../../tasks';
	import {fetchUploadedFile} from '../../store/files';

	export default {
		name: 'DataTypeMap',

		props: {
			meta: Object,
			supportNext: Boolean
		},

		data() {
			const file = this.$store.getters.getActiveFile(this.meta.type);
			const columns = file.columns;
			const map = columns.reduce((map, column) => ({
				...map,
				[column.slug]: {
					keep: column.hasOwnProperty('keep') ? column.keep : true,
					type: column.type
				}
			}), {});

			return {
				file,
				columns,

				map,
				isSaving: false,
				isDirty: false
			};
		},

		watch: {
			map: {
				handler() {
					this.isDirty = true;
				},
				deep: true
			}
		},

		methods: {
			onSuccess() {
				this.$emit('success');
			},

			onSave() {
				this.isSaving = true;

				const data = {
					id: this.file.id,
          map: this.map
        };

				axios.post(fullURL('/file/recompute'), data)
					.then(({data}) => this.monitorTask(data))
					.catch(e => {
						console.log("DataTypeMap: Error occurred while initiating recompute");
						console.log(e);
						this.isSaving = false;
          });
			},

			monitorTask(taskID) {
				console.log("DataTypeMap: Monitor recompute task");
				registerListener(taskID, (event, data) => {
					if (event === 'success') {
						this.$store.dispatch(fetchUploadedFile(data.fileID))
							.then(() => {
								console.log("DataTypeMap: Successfully fetched file after recalculation");
								this.onSuccess();
							})
							.catch(console.log)
							.finally(() => {
								this.isSaving = false;
							});
					} else if (event === 'failure') {
						console.log('The process failed', data.message);
						this.isSaving = false;
					} else {
						return;
					}

					unregisterListener(taskID);
				});
			}
		}
	};
</script>

<style scoped>

</style>
